exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb li[data-v-4670e82a] {\n  font-weight: bold;\n  text-transform: uppercase;\n}", ""]);

// exports
